import Admin from "pages/Admin";
import App from "pages/App";
import ClaimProfile from "pages/ClaimProfile";
import ClaimOtpVarification from "pages/ClaimProfile/components/ClaimOtpVerification";
import ClaimProfileSignup from "pages/ClaimProfile/components/ClaimProfileSignup";
import ClaimProfileNew from "pages/ClaimProfileNew";
import ClaimVerifyOTP from "pages/ClaimProfileNew/ClaimVerifyOTP";
import ClaimProfileEmailVerification from "pages/ClaimProfileNew/EmailVerification";
import ForgotPasswordNew from "pages/ForgotPasswordNew";
import Index from "pages/Index";
import Institutions from "pages/Institutions";
import LoginNew from "pages/LoginNew";
import Onboarding from "pages/Onboarding";
import OtpVarification from "pages/Register/components/OtpVarification";
import RegisterNewWithEmail from "pages/RegisterNew/WithEmail";
import RegisterPatient from "pages/RegisterPatient";
import ResetPassword from "pages/ResetPassword";
import SocialOAuth from "pages/SocialOAuth";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { authSetUser } from "redux-helpers/ActionCreator";
import { getToken, getUser, isAdmin } from "utils/UserHelper";

// AuthGuard component for redirection of restricted pre login component
const AuthGuard = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  let currentUser = useSelector((state) => state.auth.currentUser);
  const jobDetailsPagetUrl = new URLSearchParams(rest.location.search).get('jobdetails') ?? null;
  // Handle session inconsistency between different browser tabs
  if (!isAdmin() && getToken() && !!currentUser?.guid === false) {
    const user = getUser();
    currentUser = user;
    dispatch(authSetUser(user));
  }
  return getToken() ? (
    isAdmin() ? (
      <Redirect to={`/admin`} />
    ) : (
      <>
          {jobDetailsPagetUrl !== null ?
            <Redirect to={`/jobs/${jobDetailsPagetUrl}`}/>
          :
          <Redirect to={`/home`} />
        }
      </>      
    )
  ) : (
    <Route {...rest} component={Component} />
  );
};

const AppContainer = () => {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<div />}>
        <Switch>
          <Route exact path="/claim-profile-new" component={ClaimProfileNew} />
          <Route
            exact
            path="/claim-profile-new/email/:phone/:guid"
            component={ClaimProfileEmailVerification}
          />
          <Route
            exact
            path="/claim-profile-new/verify-otp"
            component={ClaimVerifyOTP}
          />
          <Route exact path="/onboarding" component={Onboarding} />
          <AuthGuard exact path="/" component={Index} />
          <AuthGuard exact path="/login" component={LoginNew} />
          <AuthGuard
            exact
            path="/claim-profile/:userName/:id"
            component={ClaimProfile}
          />
          <AuthGuard
            exact
            path="/claimOtp-verification"
            component={ClaimOtpVarification}
          />
          <AuthGuard
            exact
            path="/claim-profile-signup"
            component={ClaimProfileSignup}
          />
          <AuthGuard exact path="/register" component={ClaimProfileNew} />
          <AuthGuard
            exact
            path="/profile-claim/:profileId"
            component={ClaimProfileNew}
          />
          <AuthGuard
            exact
            path="/register/withEmail/:guid"
            component={RegisterNewWithEmail}
          />
          <AuthGuard
            exact
            path="/register/otp-verification/:type"
            component={ClaimVerifyOTP}
          />
          <AuthGuard
            exact
            path="/register/otp-verification-email"
            component={ClaimProfileEmailVerification}
          />
          <Route exact path="/register/onboarding" component={Onboarding} />
          <Route exact path="/register/user-account" component={RegisterPatient} />
          <AuthGuard
            exact
            path="/otp-verification"
            component={OtpVarification}
          />
          <AuthGuard
            exact
            path="/forgot-password"
            component={ForgotPasswordNew}
          />
          <AuthGuard
            exact
            path="/reset-password/:token"
            component={ResetPassword}
          />
          <AuthGuard exact path="/oauth2/redirect" component={SocialOAuth} />
          {/* <Route path="/institution/:institutionID" component={Institutions} /> */}
          <Route path="/admin" component={Admin} />
          <Route render={() => <App />} />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};
export default AppContainer;
